<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Partner List</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Create New Partner List</b>
          <b-row class="mt-4">
            <b-col md="8">
              <b-form-group
                id="fieldset-1"
                label="Partner Name"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required'"
                  v-model="partner_name"
                  name="name"
                  data-vv-as="Partner Name"
                  id="input-1"
                  class="form-control"
                  placeholder="Partner Name"
                />
                <b-form-invalid-feedback id="input-name-feedback">{{
                  veeErrors.first("name")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="8">
              <b-form-group
                id="input-group-1"
                label-class="control-label mb-n1"
                class="required"
                label="Image (Mobile)"
                label-for="input-1"
              ></b-form-group>
              <b-card body-class="py-2 px-2">
                <card-body>
                  <b-row>
                    <b-col class="text-primary mt-2">
                      <i class="fas fa-paperclip"></i>&nbsp;
                      <b>{{ image.name || "Name" }}</b>
                      <sup class="text-secondary pl-3"
                        >(2 Mb)&nbsp;(180px x 100px)</sup
                      >
                    </b-col>
                    <b-col md="6" class="text-right" align="right">
                      <input
                        type="file"
                        ref="image"
                        name="image"
                        v-validate="
                          'required|image|minimalDimensions:180,100|ratiolDimensions:9,5|size:2000|ext:jpg,png,gif,jpeg'
                        "
                        style="display: none"
                        v-on:change="onChangeimage()"
                      />
                      <b-button
                        @click="$refs.image.click()"
                        v-show="!image"
                        variant="primary"
                        class="ml-5"
                        >Select File</b-button
                      >
                      <b-button
                        v-show="image"
                        variant="primary"
                        @click="modalImage = !modalImage"
                        class="mr-2"
                        >Preview</b-button
                      >
                      <b-button
                        @click="$refs.image.click()"
                        v-show="image"
                        variant="outline-primary"
                        class
                        >Change File</b-button
                      >
                    </b-col>
                  </b-row>
                </card-body>
              </b-card>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("image") }}
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label="Status" label-for="input-1">
                <b-form-radio-group
                  id="radio-group-2"
                  v-model="status"
                  :options="options2"
                  name="radio-status"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button
                variant="primary"
                :disabled="loading"
                @click="post()"
                class="mr-3"
                size="lg"
              >
                Create
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{ name: 'CorpPartnerList' }">
                <b-button variant="outline-secondary" size="lg"
                  >Cancel</b-button
                >
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      partner_name: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      status: "",
      modalImage: false,
      options2: [
        { text: "Publish", value: "publish" },
        { text: "Archive", value: "archive" },
      ],
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("partner_name", this.partner_name);
          formData.append("image_jpg", this.image);
          formData.append("status", this.status);
          this.$store
            .dispatch("CorpSalesPartnerModule/postCorpPartnerList", formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: "CorpPartnerList" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
